// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__2YA48","Container":"Footer__Container__H3FyJ","Text":"Footer__Text__262dT","Title":"Footer__Title__3X6EN","Logo":"Footer__Logo__sfAYe","Nav":"Footer__Nav__2eW_p","SiteMapItems":"Footer__SiteMapItems__kyzi-","Map":"Footer__Map__1eLvc","Left":"Footer__Left__3wbit","Right":"Footer__Right__294Wg","pulse":"Footer__pulse__2wKT1","MobileNav":"Footer__MobileNav__1AECE","SocialBar":"Footer__SocialBar__1gPJD","Copyright":"Footer__Copyright__2ajYq","SwitchColor":"Footer__SwitchColor__267a2"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Footer/Footer.css
// module id = 324
// module chunks = 0